import { createContext, useContext, useState } from "react";

export const GravityFormsContext = createContext();

/**
 * useGravityFormsContext
 */

export function useGravityFormsContext(data) {
  const formId = data?.formId;
  const submit = data?.submitButton;
  const fields = data?.fields
    ? data.fields
    : data?.formFields.edges.map(({ node }) => node);

  const [formFileUploads, setFormFileUploads] = useState(false);

  return {
    formId,
    submit,
    fields,
    formFileUploads,
    setFormFileUploads,
  };
}

/**
 * useGravityForms
 */

export default function useGravityForms() {
  const form = useContext(GravityFormsContext);
  return form;
}
